import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/simp_in/step3';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { TypeMarcheReserve } from '../models/TypeMarcheReserve';
@Component({
	selector: 'app-type-marche-reserve',
	templateUrl: './type-marche-reserve.component.html'
})
export class TypeMarcheReserveComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeMarcheReserve';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() reservationMarche: TypeMarcheReserve;

	public radioButtonValue: string;
	public radioButtonCtrlName: string;
	public radioCheckBoxEnum = RadioCheckBoxEnum;
	public step3 = new Step3();

	constructor() {}

	public ngOnInit() {
		if (this.reservationMarche?.servicesSociaux === '') {
			this.radioButtonValue = this.radioCheckBoxEnum.servicesSociauxValue;
		} else if (this.reservationMarche?.structureInsertion === '') {
			this.radioButtonValue = this.radioCheckBoxEnum.structureInsertionValue;
		} else if (this.reservationMarche?.entrepriseAdaptee === ''){
			this.radioButtonValue = this.radioCheckBoxEnum.entrepriseAdapteeValue;
		}
		this.radioButtonCtrlName = this.getUid() + '_SepAtt_MarcheReserveRadio';
}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
